import { Box, Button, Checkbox, Link, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useState } from 'react';
import DialogCotacaoFornecedor from './DialogCotacaoFornecedor';
import { DetalheSolicitacaoData, ItemSolicitacao } from "../index";
import { useModalDetalheProduto } from '../../../../MIProdutos/ModalDetalheProdutoContext';

export interface CardItensSolicitacaoProps {
    data: DetalheSolicitacaoData;
}

export default function CardItensSolicitacao({ data }: CardItensSolicitacaoProps) {

    const { openModal } = useModalDetalheProduto();

    const [openCotacao, setOpenCotacao] = useState<ItemSolicitacao[] | null>(null);
    const [selectedItens, setSelectedItens] = useState<ItemSolicitacao[]>([]);

    const handleSelectItem = (item: ItemSolicitacao) => {
        setSelectedItens((prev) =>
            prev.includes(item)
                ? prev.filter((i) => i.id !== item.id)
                : [...prev, item]
        );
    };

    return (
        <Paper sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Itens da solicitação
            </Typography>

            <Typography variant="body2" sx={{ mb: 2 }}>
                Selecione os itens que deseja cotar com o fornecedor
            </Typography>
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell align="left" sx={{ minWidth: 160 }}><b>Produto</b></TableCell>
                        <TableCell align="right" sx={{ minWidth: 80 }}><b>Quantidade</b></TableCell>
                        <TableCell align="left" sx={{ minWidth: 120 }}><b>Status</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.itens.map((item: ItemSolicitacao) => {
                        return (
                            <TableRow key={item.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell>
                                    <Checkbox
                                        checked={selectedItens.includes(item)}
                                        onChange={() => handleSelectItem(item)}
                                        disabled={item.status_cotacao === "OC Emitida"}
                                    />
                                </TableCell>
                                <TableCell align="left" sx={{ maxWidth: 240, wordBreak: "break-word", whiteSpace: "normal" }}>
                                    <Typography noWrap={false} sx={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                                        <Link
                                            color={'primary'}
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                openModal(item.produto_id.toString())
                                            }}>
                                            {item.produto_id}
                                        </Link> - {item.nome}
                                    </Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Typography>
                                        {item.quantidade} {item.unidade_medida}
                                    </Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Typography>
                                        {item.status_cotacao}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button
                    variant="contained"
                    sx={{ background: "#005540" }}
                    disabled={selectedItens.length === 0}
                    onClick={() => {
                        setOpenCotacao(selectedItens);
                    }}
                >
                    Iniciar cotação
                </Button>
            </Box>
            {openCotacao && openCotacao.length > 0 &&
                <DialogCotacaoFornecedor
                    solicitacaoId={data.id}
                    open={Boolean(openCotacao)}
                    itens={openCotacao}
                    onClose={() => setOpenCotacao(null)}
                />
            }
        </Paper>
    )
}